import React, { PureComponent } from 'react'
import { is } from 'immutable'
import { isURL } from 'validator'
import Input from 'shared-web/src/components/Input'
import Toggle from 'components/Toggle'

import { Subsection, Row } from 'components/settings/UserProfile/Section'
import ManageCalendarLink from './ManageCalendarLink'
import CalendarField from './CalendarField'

import styles from './styles.styl'

const SocialHandle = ({ name, title, url, value, onChange, style }) => (
  <div className={styles.SocialHandle} style={style}>
    <div className="dsg-Label">{title}</div>
    <div className={styles.SocialHandle__InputContainer}>
      <div className={styles.SocialHandle__URL}>{url}</div>
      <Input
        className={styles.SocialHandle__Input}
        size="small"
        name={name}
        placeholder="username"
        value={value}
        onChange={onChange}
        isValid={true}
      />
    </div>
  </div>
)

export default class ContactInfo extends PureComponent {
  handleChange = event => {
    this.props.actions.setProfileUIData({
      key: event.target.name,
      value: event.target.type === 'checkbox' ? event.target.checked : event.target.value,
    })
  }

  handleSave = () => {
    if (!this.canSubmit()) return

    this.props.actions.updateContact()
  }

  handleCancel = () => {
    this.props.actions.setProfileUI(this.props.social)
  }

  canSubmit() {
    return !is(this.props.socialUI, this.props.social) && this.isValidCalendarCtaCopy
  }

  get calendarCtaCopyRemainingCharacters() {
    return 18 - _.get(this.props.socialUI, 'calendarCta.length', 0)
  }

  get isValidCalendarCtaCopy() {
    return this.calendarCtaCopyRemainingCharacters > -1
  }

  isValidUrl(url) {
    if (!url) { return true }
    return isURL(url) || url && url.length === 0
  }

  render() {
    const { socialUI } = this.props
    const isValidCalendarUrl = this.isValidUrl(socialUI.calendarUrl)

    return (
      <Subsection
        title="Contact"
        isValid={isValidCalendarUrl}
        canSubmit={this.canSubmit()}
        onSubmit={this.handleSave}
        onCancel={this.handleCancel}
      >
        <div className="profile-settings">
          <Row>
            <div style={{ flex: 1, marginRight: '4rem' }}>
              <div className="dsg-Label">Phone number</div>
              <Input
                size="small"
                placeholder="123-456-7890"
                value={socialUI.phoneNumber}
                name="phoneNumber"
                onChange={this.handleChange}
                isValid={true}
                type="tel"
              />
            </div>
            <div className="flex-1">
              <div className="dsg-Label">Calendar CTA</div>
              <div className="flex align-items-flex-start">
                <div className="dsg-Body" style={{ marginRight: '2.5rem' }}>
                  Display a button that allows users to book a meeting with you from your profile.
                </div>
                <Toggle
                  className="userProfile--cta-toggle"
                  name="enableCalendarCta"
                  checked={socialUI.enableCalendarCta}
                  onChange={this.handleChange}
                />
              </div>
            </div>
          </Row>
          <Row>
            <SocialHandle
              title="Twitter"
              url="twitter.com/"
              value={socialUI.twitterHandle}
              onChange={this.handleChange}
              name="twitterHandle"
              style={{ marginRight: '4rem' }}
            />
            <div className="flex-1">
              <div className="flex flex-space-between">
                <div className="dsg-Label">Calendar link</div>
                <div className="dsg-Label">
                  <ManageCalendarLink />
                </div>
              </div>
              <CalendarField
                size="small"
                value={socialUI.calendarUrl}
                placeholder="www.example.com/username"
                name="calendarUrl"
                onChange={this.handleChange}
                isValid={isValidCalendarUrl}
                debounceTime={1000}
              />
            </div>
          </Row>
          <Row>
            <SocialHandle
              title="LinkedIn"
              url="linkedin.com/in/"
              value={socialUI.linkedInHandle}
              onChange={this.handleChange}
              name="linkedInHandle"
              style={{ marginRight: '4rem' }}
            />
            <div className="flex-1">
              <div className="flex flex-space-between">
                <div className="dsg-Label">Calendar CTA copy</div>
                <div className={`dsg-Body ${this.isValidCalendarCtaCopy ? 'color-navy-dark' : 'color-red'}`}>
                  {this.calendarCtaCopyRemainingCharacters}
                </div>
              </div>
              <Input
                size="small"
                name="calendarCta"
                placeholder="e.g. book a demo"
                value={socialUI.calendarCta}
                onChange={this.handleChange}
                isValid={this.isValidCalendarCtaCopy}
                invalidLabel={this.isValidCalendarCtaCopy ? '' : 'CTA exceeds max length'}
              />
            </div>
          </Row>
          <Row>
            <SocialHandle
              title="Instagram"
              url="instagram.com/"
              value={socialUI.instagramHandle}
              onChange={this.handleChange}
              name="instagramHandle"
              style={{ marginRight: '4rem' }}
            />
            <SocialHandle
              title="SoundCloud"
              url="soundcloud.com/"
              value={socialUI.soundCloudHandle}
              onChange={this.handleChange}
              name="soundCloudHandle"
            />
          </Row>
          <Row>
            <SocialHandle
              title="Pinterest"
              url="pinterest.com/"
              style={{ marginRight: '4rem' }}
              value={socialUI.pinterestHandle}
              onChange={this.handleChange}
              name="pinterestHandle"
            />
            <SocialHandle
              title="Skype"
              url="skype.com/"
              value={socialUI.skypeHandle}
              onChange={this.handleChange}
              name="skypeHandle"
            />
          </Row>
          <Row>
            <div style={{ flex: '1', marginRight: '4rem' }}>
              <SocialHandle
                title="Facebook"
                url="facebook.com/"
                value={socialUI.facebookHandle}
                onChange={this.handleChange}
                name="facebookHandle"
              />
            </div>
            <div className="flex-1" />
          </Row>
        </div>
      </Subsection>
    )
  }
}



// WEBPACK FOOTER //
// ./src/scripts/components/settings/UserProfile/Sections/Profile/ContactInfo/index.js